import { component } from "picoapp";

export default component((node, ctx) => {
  const threshold = parseFloat(node.dataset.threshold || 0.5);
  const triggerOnce = node.dataset.triggerOnce !== "false";
  const delay = node.dataset.delay || 0;

  const initialClassRaw =
    node.dataset.initialClass || "opacity-0 translate-y-8";
  const initialClasses = initialClassRaw.split(" ");

  const animationClassRaw =
    node.dataset.animationClass ||
    "animate-scroll-in opacity-100 translate-y-0";
  const animationClasses = animationClassRaw.split(" ");

  if (delay) {
    node.classList.add(delay);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log(animationClassRaw);
          node.classList.add(...animationClasses);

          node.classList.remove(...initialClasses);

          if (triggerOnce) {
            observer.unobserve(node);
          }
        } else {
          if (!triggerOnce) {
            node.classList.remove(...animationClasses);
            node.classList.add(...initialClasses);
          }
        }
      });
    },
    { threshold: threshold }
  );

  observer.observe(node);
});
